import { Grid, useEventCallback } from '@mui/material';
import { Fragment, memo, useMemo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import { DatePicker } from '@mui/lab';
import PmiTextField from 'shell/components/shared/text-field';
import { ConfigurationType } from 'civil-status/constants/configuration-type';
import { SelectChangeEvent } from '@mui/material';
import ListTypeRequest from '../list/list-type-request';

interface GeneralDataOathProps {
  disabled?: boolean;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  onChanges: (values: SectionVM) => void;
  configuration?: string;
}

const GeneralDataOathComponent = ({
  disabled = false,
  values,
  errors,
  touched,
  onChange,
  configuration,
}: GeneralDataOathProps): React.ReactElement => {
  const isGiuriCit2 = useMemo(() => {
    return configuration === ConfigurationType.GIURCIT2;
  }, [configuration]);

  const handleListTypeRequest = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('typeRequest', event.target.value);
  });

  return (
    <Grid container spacing={2} item>
      {isGiuriCit2 ? (
        <Fragment>
          <Grid item xs={12} md={6}>
            <ListTypeRequest
              value={values?.typeRequest || ''}
              onChange={handleListTypeRequest}
              disabled={disabled}
              error={Boolean(errors?.typeRequest) && touched?.typeRequest}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <DatePicker
              label="Data richiesta *"
              aria-label="Data richiesta"
              value={values?.dateTranscription || null}
              onChange={(date) => {
                onChange('dateTranscription', date);
              }}
              disabled={disabled}
              renderInput={(params) => (
                <PmiTextField
                  {...params}
                  id="dateRequest"
                  fullWidth
                  helperText={errors?.dateTranscription}
                  error={touched?.dateTranscription && Boolean(errors?.dateTranscription)}
                />
              )}
            />
          </Grid>
        </Fragment>
      ) : undefined}
      <Grid item xs={12} md={6}>
        <DatePicker
          label="Data giuramento *"
          aria-label="Data giuramento"
          value={values?.dateOath || null}
          onChange={(date) => {
            onChange('dateOath', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateOath"
              fullWidth
              helperText={errors?.dateOath}
              error={touched?.dateOath && Boolean(errors?.dateOath)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Estremi giuramento *"
          aria-label="Estremi giuramento"
          id="extremesOath"
          name="extremesOath"
          fullWidth
          disabled={disabled}
          helperText={errors?.extremesOath}
          error={touched?.extremesOath && Boolean(errors?.extremesOath)}
          type="text"
          variant="outlined"
          multiline
          value={values?.extremesOath || ''}
          onChange={(event) => {
            onChange('extremesOath', event.target.value);
          }}
        />
      </Grid>
      {isGiuriCit2 ? (
        <Fragment>
          <Grid item xs={12} md={6}>
            <DatePicker
              label="Data verbale *"
              aria-label="Data verbale"
              value={values?.dateReport || null}
              onChange={(date) => {
                onChange('dateReport', date);
              }}
              disabled={disabled}
              renderInput={(params) => (
                <PmiTextField
                  {...params}
                  id="dateReport"
                  fullWidth
                  helperText={errors?.dateReport}
                  error={touched?.dateReport && Boolean(errors?.dateReport)}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <PmiTextField
              label="Protocollo richiesta *"
              aria-label="Protocollo richiesta"
              id="requestProtocol"
              name="requestProtocol"
              fullWidth
              disabled={disabled}
              helperText={errors?.requestProtocol}
              error={touched?.requestProtocol && Boolean(errors?.requestProtocol)}
              type="text"
              variant="outlined"
              multiline
              value={values?.requestProtocol || ''}
              onChange={(event) => {
                onChange('requestProtocol', event.target.value);
              }}
            />
          </Grid>
        </Fragment>
      ) : undefined}
    </Grid>
  );
};

GeneralDataOathComponent.displayName = 'Form General Data Oath component';

const GeneralDataOath = memo(GeneralDataOathComponent);

export default GeneralDataOath;
